import { iframeDataBridge } from '@/iframe/iframeDataBridge';

// Customer-scoped point matrices.
// Add an entry per customer reference to enable scoring for that customer.
// ⚠️  INNOCENT thresholds are placeholders — replace with the actual matrix before go-live.
const MATRICES = {
	INNOCENT: {
		basePointsPerUnit: 1,
		bonusMEA: 10,
		thresholds: [
			{ minVolume: 0, multiplier: 1 },
			{ minVolume: 100, multiplier: 1.5 },
			{ minVolume: 500, multiplier: 2 },
		],
	},
};

function getActiveMatrix() {
	const ref = (iframeDataBridge.getCustomer() ?? '').toUpperCase();
	return MATRICES[ref] ?? null;
}

export function isScoringMatrixAvailable() {
	return getActiveMatrix() !== null;
}

/**
 * @param {{ volumeUC?: number, meaCount?: number }} params
 * @returns {number} computed points, or 0 if no matrix applies for the current customer
 */
export function calculatePoints({ volumeUC = 0, meaCount = 0 } = {}) {
	const matrix = getActiveMatrix();
	if (!matrix) return 0;

	const threshold = [...matrix.thresholds].reverse().find((t) => volumeUC >= t.minVolume) ?? matrix.thresholds[0];
	const base = Math.floor(volumeUC * matrix.basePointsPerUnit * threshold.multiplier);
	const meaBonus = meaCount * matrix.bonusMEA;
	return base + meaBonus;
}
